var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.754","style":{"isolation":"isolate"}},React.createElement("path",{"d":"M446.332,35.813c-6.511-7.739-18.531-10.9-41.487-10.9h-83.33c-23.481,0-35.705,3.361-42.191,11.6C273,44.551,273,56.388,273,72.771V104c0,31.738,7.5,47.853,48.515,47.853h83.331c19.907,0,30.938-2.786,38.075-9.616,7.319-7,10.441-18.439,10.441-38.237V72.771C453.362,55.494,452.873,43.587,446.332,35.813ZM388.793,92.694l-37.84,19.776a5.818,5.818,0,0,1-8.513-5.157V67.888a5.818,5.818,0,0,1,8.5-5.163l37.84,19.649a5.818,5.818,0,0,1,.013,10.32Z","transform":"translate(-273 -24.917)","fill":"#b30018"})));
}

Play.defaultProps = {"width":"180.362","height":"126.932","viewBox":"0 0 180.362 126.932"};

module.exports = Play;

Play.default = Play;
